import type { AssetColors } from './asset-colors.js';

export const DARK_ASSETS: AssetColors = {
  giwa: '#444444',
  thatch: '#c8a838',
  evergreenLight: '#6db86d',
  evergreenDark: '#2d5a3d',
  trunk: '#6b4226',
  pine: '#2a6e1e',
  leaf: '#3d8c2a',
  bush: '#357a22',
  roofA: '#c45435',
  roofB: '#d4924a',
  wall: '#d4c8a0',
  wallShade: '#b0a078',
  church: '#e0d8c0',
  fence: '#9e8a60',
  wheat: '#d4b840',
  sheep: '#e8e8e0',
  sheepHead: '#333',
  cow: '#8b5e3c',
  cowSpot: '#f5f0e0',
  chicken: '#d4a030',
  whale: '#4a7a9e',
  whaleBelly: '#8ab4c8',
  boat: '#8b6840',
  sail: '#e8e0d0',
  fish: '#70b0c8',
  flag: '#cc3333',
  windmill: '#c8b888',
  windBlade: '#d8d0b8',
  well: '#7a6a4a',
  chimney: '#8a6a4a',
  path: '#a09068',
  water: '#3a6a9e',
  waterLight: '#5a90be',
  deer: '#8a6030',
  horse: '#6e4422',
  flower: '#e06080',
  flowerCenter: '#f0d040',
  mushroom: '#e8dcc8',
  mushroomCap: '#c44030',
  rock: '#808080',
  boulder: '#6a6a6a',
  palm: '#4a8828',
  willow: '#558838',
  seagull: '#e0e0e0',
  dock: '#7a6040',
  tent: '#c8b888',
  tentStripe: '#cc4444',
  hut: '#a08860',
  market: '#d8c898',
  marketAwning: '#cc5533',
  inn: '#c8a878',
  innSign: '#d4a040',
  blacksmith: '#555555',
  anvil: '#444444',
  castle: '#a0a0a0',
  castleRoof: '#606080',
  tower: '#909090',
  bridge: '#8a7a5a',
  cart: '#8a6a40',
  barrel: '#7a5a30',
  torch: '#6a5030',
  torchFlame: '#ff9922',
  cobble: '#888878',
  smoke: 'rgba(180,180,180,0.4)',
  bird: '#444444',
  scarecrow: '#8a7040',
  scarecrowHat: '#5a4020',
  stump: '#6b4a26',
  riverOverlay: 'rgba(35,85,160,0.60)',
  pondOverlay: 'rgba(25,75,150,0.65)',
  reeds: '#6a8838',
  fountain: '#909090',
  fountainWater: '#70a8d0',
  canal: '#7a7a6a',
  gardenTree: '#4a9a3a',
  ricePaddy: '#8aaa48',
  ricePaddyWater: '#4a88b0',
  // New 118-type expansion colors
  jellyfish: '#9a70c0',
  coral: '#d06858',
  turtle: '#5a8848',
  buoy: '#cc4444',
  lighthouse: '#d8d0b8',
  crab: '#c06030',
  driftwood: '#8a7050',
  sandcastle: '#d8c890',
  tidePools: '#5a90b0',
  heron: '#a0a8b0',
  shellfish: '#c0a880',
  cattail: '#6a8838',
  frog: '#4a8830',
  lily: '#e088a0',
  rabbit: '#b0a090',
  fox: '#c06a28',
  butterfly: '#d070a0',
  butterflyWing: '#e0a040',
  beehive: '#c0a040',
  wildflower: '#d060d0',
  tallGrass: '#5a9838',
  birchBark: '#e0d8c8',
  haybale: '#c0a848',
  owl: '#8a7050',
  squirrel: '#a06030',
  moss: '#4a7a30',
  fern: '#3a8828',
  deadTree: '#6a5a40',
  log: '#7a5a30',
  berryBush: '#3a7828',
  berry: '#cc3030',
  spiderWeb: 'rgba(200,200,200,0.5)',
  silo: '#a0a0a0',
  pig: '#e0a8a0',
  trough: '#7a6a50',
  haystack: '#c8a838',
  orchard: '#4a8828',
  orchardFruit: '#cc4430',
  beeFarm: '#c8b060',
  pumpkin: '#d07020',
  tavern: '#a08860',
  tavernSign: '#8a6830',
  bakery: '#c8a878',
  stable: '#8a7050',
  gardenFence: '#e0d8c0',
  laundry: '#e0d8e8',
  doghouse: '#8a6030',
  shrine: '#a0a0a8',
  wagon: '#8a6840',
  cathedral: '#c0b8a8',
  cathedralWindow: '#4080c0',
  library: '#b0a088',
  clocktower: '#a0a0a0',
  clockFace: '#e8e0c8',
  statue: '#909098',
  parkBench: '#6a5a40',
  warehouse: '#8a8078',
  gatehouse: '#a09888',
  manor: '#c8b898',
  manorGarden: '#4a8838',
  signpost: '#7a6040',
  lantern: '#6a5a40',
  lanternGlow: '#ffc840',
  woodpile: '#7a5a30',
  puddle: '#5a88b8',
  campfire: '#6a5030',
  campfireFlame: '#ff6622',
  // Seasonal: Winter
  snowCap: '#e8eef5',
  snowGround: '#d8e2ee',
  ice: '#a0c0e0',
  icicle: '#b0d4f0',
  frozenWater: '#6090b8',
  igloo: '#dce8f2',
  sledWood: '#8a5a30',
  sledRunner: '#607080',
  scarfRed: '#cc3030',
  snowmanCoal: '#2a2a2a',
  snowmanCarrot: '#e07020',
  winterBirdRed: '#cc3030',
  winterBirdBrown: '#8a6040',
  firewoodLog: '#6a4020',
  bareBranch: '#6a5a4a',
  frostWhite: '#e0e8f0',
  // Seasonal: Spring
  cherryPetalPink: '#f5a0b8',
  cherryPetalWhite: '#f8e0e8',
  cherryTrunk: '#6a4030',
  cherryBranch: '#7a5040',
  tulipRed: '#e04050',
  tulipYellow: '#f0d040',
  tulipPurple: '#9050c0',
  tulipStem: '#5a9a40',
  sproutGreen: '#80d050',
  nestBrown: '#7a5530',
  eggBlue: '#a8d8e8',
  eggWhite: '#f0ece0',
  crocusPurple: '#8040b0',
  crocusYellow: '#e8c830',
  lambWool: '#f0ece5',
  birdhouseWood: '#a07040',
  gardenSoil: '#5a4030',
  // Seasonal: Summer
  parasolRed: '#e04040',
  parasolBlue: '#4080d0',
  parasolYellow: '#e8c820',
  parasolStripe: '#ffffff',
  beachTowelA: '#e05050',
  beachTowelB: '#4090d0',
  sandcastleWall: '#d8c090',
  surfboardBody: '#e0e0e0',
  surfboardStripe: '#e04040',
  iceCreamCart: '#f0e8d0',
  iceCreamUmbrella: '#e04040',
  hammockFabric: '#d09050',
  sunflowerPetal: '#f0c820',
  sunflowerCenter: '#5a3a20',
  watermelonRind: '#40a040',
  watermelonFlesh: '#e04040',
  watermelonSeed: '#2a2a2a',
  lemonadeStand: '#f0d880',
  sprinklerMetal: '#8090a0',
  poolWater: '#60b8e0',
  poolEdge: '#c0c8d0',
  // Seasonal: Autumn
  mapleRed: '#c83020',
  mapleCrimson: '#a02020',
  mapleOrange: '#d07020',
  oakGold: '#c8a030',
  oakBrown: '#8a6030',
  birchYellow: '#d8c040',
  ginkgoYellow: '#d8c830',
  fallenLeafRed: '#c04030',
  fallenLeafOrange: '#d08030',
  fallenLeafGold: '#d0a030',
  fallenLeafBrown: '#8a5a30',
  acornBody: '#8a6030',
  acornCap: '#5a3820',
  cornStalkColor: '#c8a860',
  cornEar: '#d8c060',
  harvestApple: '#c83030',
  harvestGrape: '#6030a0',
  hotDrinkMug: '#c8a060',
  hotDrinkSteam: '#d0d8e0',
  wreathGreen: '#507038',
  wreathBerry: '#c03030',
  // Extended Seasonal: Autumn
  autumnGold: '#d4a84b',
  autumnBronze: '#b07830',
  autumnBurgundy: '#8b2040',
  autumnRust: '#c05530',
  autumnOlive: '#8b8b40',
  // Extended Seasonal: Spring
  blossomPink: '#ffb6c1',
  blossomWhite: '#fff0f5',
  peachPink: '#ffd5cc',
  // Extended Seasonal: Winter
  icicleBlue: '#d0e8f8',
  christmasRed: '#c41e3a',
  christmasGold: '#ffd700',
  christmasGreen: '#228b22',
  // Fruit Trees
  appleRed: '#c41e3a',
  oliveGreen: '#808060',
  oliveFruit: '#4a4a30',
  lemonYellow: '#fff44f',
  orangeFruit: '#ff8c00',
  pearGreen: '#d1e231',
  peachFruit: '#ffcba4',
  // Additional Livestock
  donkey: '#808080',
  goat: '#e8e0d0',
  goatHorn: '#b0a090',
  // Enhanced asset detail colors
  shadow: '#1a1a2e',
  bushDark: '#2d5a3d',
  leafLight: '#6db86d',
  flowerAlt: '#e8a0c0',
  // Epic building colors
  epicGold: '#ffd700',
  epicMarble: '#d8d0c0',
  epicJade: '#2e8b57',
  epicCrystal: '#7fdbff',
  epicMagic: '#9b59b6',
  epicPortal: '#00ced1',
};
